import CrudCustom from '../../../libs/custom/CrudCustom';

let TipeIndustriService = new CrudCustom('/tipe-industries');
export default TipeIndustriService;
